<div class="block-container p-md" *ngIf="block" [ngClass]="{ 'block-editable': isEditable }">
  <div class="row">
    <div class="col-md-12 d-flex justify-content-end">
      <div *ngIf="isEditable">
        <arsultima-ui-button-edit-contextual
          (click)="editBlock()"
          [tooltip]="'buttons.editBlock' | transloco"
        ></arsultima-ui-button-edit-contextual>
      </div>
    </div>
  </div>
  <div class="row" *ngIf="block.blocktitle">
    <div class="col-md-12 d-flex justify-content-center">
      <div class="title">
        <arsultima-page-title [pageTitle]="block.blocktitle"></arsultima-page-title>
        <span class="text-page-subtitle d-flex justify-content-center" *ngIf="block.blocksubtitle">
          {{ block.blocksubtitle }}
        </span>
      </div>
    </div>
  </div>
  <div class="row" *ngIf="block.blocktext">
    <div class="col-md-12 d-flex justify-content-center mt-3">
      <arsultima-block-separator *ngIf="block.blocktext"></arsultima-block-separator>
    </div>
  </div>
  <div class="row" *ngIf="block.blocktext">
    <div class="col-md-12">
      <div class="block block-text">
        <markdown [data]="block.blocktext"></markdown>
      </div>
    </div>
  </div>
  <div class="row" *ngIf="block.nom_pic">
    <div class="col-md-12 pt-3">
      <div>
        <img [src]="imageUrl" alt="" />
      </div>
    </div>
  </div>
</div>
